import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=bf58f1d0&scoped=true&"
import script from "./Paper.vue?vue&type=script&lang=js&"
export * from "./Paper.vue?vue&type=script&lang=js&"
import style0 from "./Paper.vue?vue&type=style&index=0&id=bf58f1d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf58f1d0",
  null
  
)

export default component.exports